import { createContext, useContext, useState } from "react";
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../../Admin/Config/Config";
// import { onAuthStateChanged } from "firebase/auth";

const ProductsContext = createContext();

export const ProductsProvider = ({ children }) => {
  const [productList, setProductList] = useState([]);
  // const [rawProducts, setRawProducts] = useState([]);
  // const [uid, setUid] = useState(null);
  // const [userDetails, setUserDetails] = useState(null);

  // Handle auth/user state
  // useEffect(() => {
  //   const unsubscribe = onAuthStateChanged(auth, async (user) => {
  //     if (user) {
  //       // setUid(user.uid);
  //       const userRef = doc(db, "users", user.uid);
  //       const userDoc = await getDoc(userRef);

  //       if (userDoc.exists()) {
  //         setUserDetails(userDoc.data());
  //       }
  //     } else {
  //       // setUid(null);
  //       setUserDetails(null);
  //     }
  //   });

  //   return () => unsubscribe();
  // }, []); // no need to depend on uid

  // Fetch products and listen for updates
  const fetchProducts = ({ filters = [], sort = null, limitCount = null }) => {
    let q = query(collection(db, "products"));

    if (filters.length > 0) {
      filters.forEach((f) => {
        q = query(q, where(f.field, f.op, f.value));
      });
    }

    if (sort) {
      q = query(q, orderBy(sort.field, sort.direction || "asc"));
    }

    if (limitCount) {
      q = query(q, limit(limitCount));
    }

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const products = querySnapshot.docs.map((docu) => ({
        id: docu.id,
        ...docu.data(),
      }));
      setProductList(products);
    });

    return unsubscribe;
  };

  // Recompute product prices when userDetails or rawProducts change
  // useEffect(() => {
  //   const updatePrices = async () => {
  //     if (!rawProducts.length) {
  //       setProductList([]);
  //       return;
  //     }

  //     const updatedProducts = await Promise.all(
  //       rawProducts.map(async (prod) => {
  //         let offer_price = 0;
  //         let original_price = 0;

  //         if (userDetails?.schemeId) {
  //           const priceRef = doc(
  //             db,
  //             "product_price",
  //             userDetails.schemeId,
  //             "products",
  //             prod.id
  //           );
  //           const priceSnap = await getDoc(priceRef);
  //           if (priceSnap.exists()) {
  //             offer_price = priceSnap.data().offer_price;
  //             original_price = priceSnap.data().original_price;
  //           }
  //         }

  //         return {
  //           ...prod,
  //           offer_price,
  //           original_price,
  //         };
  //       })
  //     );

  //     setProductList(updatedProducts);
  //   };

  //   updatePrices();
  // }, [userDetails, rawProducts]);

  return (
    <ProductsContext.Provider value={{ productList, fetchProducts }}>
      {children}
    </ProductsContext.Provider>
  );
};

export const useProducts = () => useContext(ProductsContext);
